// Add your custom JS here.

jQuery(function($) {
    // When scrolled past 200px, add class to #main-nav
    $(window).scroll(function() {
        if ($(this).scrollTop() > 200) {
            $('#main-nav').addClass('scrolled uk-animation-slide-top-small shadow-sm');
        } else {
            $('#main-nav').removeClass('scrolled uk-animation-slide-top-small shadow-sm');
        }
    });

    // toTopButton
    $(window).scroll(function() {
        if ($(this).scrollTop() > 300) {
            $('#toTopButton').removeClass('hidden');
        } else {
            $('#toTopButton').addClass('hidden');
        }
    });
    // Smoothly scroll back to top when the button is clicked
    $('#toTopButton').click(function(event) {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    $(document).on('click', '.bulletin-title', function() {
        var targetId = $(this).data('bulletin-target');
        $('.bulletin-info[data-bulletin-id="' + targetId + '"]').fadeIn(200);
    });

    $(document).on('click', '.bulletin-close', function() {
        var targetId = $(this).closest('.bulletin-info').data('bulletin-id');
        $('.bulletin-info[data-bulletin-id="' + targetId + '"]').fadeOut(200);
    });
    
    $(document).ready(function() {
        // Smooth scrolling
        $('a[href*="#"]').on('click', function(e) {
            e.preventDefault();
    
            var target = $(this.hash);
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - 100
                }, 0);

                $('.navbar-collapse').collapse('hide');
            }
        });

        // Pentagon animations
        $(document).on('inview', function(event) {
            var targetElement = $(event.target);
            if (targetElement.hasClass('pentagons')) {
                targetElement.find('.pentagon-secondary').each(function(index) {
                    var pentagon = $(this);
                    setTimeout(function() {
                        pentagon.addClass('reflected');
                        
                        // Check if this is the last element
                        if (index === targetElement.find('.pentagon-secondary').length - 1) {
                            // If it's the last element, add the 'hover' class after a delay
                            setTimeout(function() {
                                targetElement.find('.pentagon-secondary').addClass('hover');
                            }, 1500); // Adjust delay as needed, ensure it's longer than the animation duration
                        }
                    }, index * 300); // Add a delay of 300ms * index
                });
            }
        });

        // Pentagon backgrounds
        $('.pentagon-bg').append(function() {
            // add pentagon svg to pentagon-bg
            // return '<div class="pentagon-shape" uk-scrollspy="cls:uk-animation-slide-right-medium;delay:1000"><svg height="60px" width="60px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.01 512.01" xml:space="preserve"><g><g><path d="M507.804,200.28L262.471,12.866c-3.84-2.923-9.131-2.923-12.949,0L4.188,200.28c-3.605,2.773-5.077,7.531-3.648,11.84l93.717,281.92c1.451,4.373,5.525,7.296,10.133,7.296h303.253c4.587,0,8.683-2.944,10.133-7.296l93.717-281.92C512.882,207.789,511.41,203.053,507.804,200.28z"/></g></g></svg></div>';
            return '<div class="pentagon-shape" uk-scrollspy="cls:uk-animation-slide-right-medium;delay:1000"><svg uk-parallax="target: .pentagon-shape; start: 100%; end: 100%; y: 200; easing: -2" height="60px" width="60px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.01 512.01" xml:space="preserve"><g><g><path d="M507.804,200.28L262.471,12.866c-3.84-2.923-9.131-2.923-12.949,0L4.188,200.28c-3.605,2.773-5.077,7.531-3.648,11.84l93.717,281.92c1.451,4.373,5.525,7.296,10.133,7.296h303.253c4.587,0,8.683-2.944,10.133-7.296l93.717-281.92C512.882,207.789,511.41,203.053,507.804,200.28z"/></g></g></svg></div>';
        });

        // Bulletins pagination handling
        var currentPage = 1;
        function filterBulletins() {
            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: {
                    action: 'filter_bulletins',
                    page: currentPage
                },
                beforeSend: function() {
                    $('#bulletinsList').html('<div class="my-6 py-6 text-center"><div class="my-lg-6 spinner-grow text-primary text-center mx-auto" role="status"><span class="visually-hidden">Loading...</span></div></div>');
                },
                success: function(response) {
                    $('#bulletinsList').html(response);
                }
            });
        }
        $(document).on('click', '.bulletins-pagination .pagination a', function(e) {
            e.preventDefault();
            var href = $(this).attr('href');
            currentPage = $(this).attr('data-page'); // Update the page number from pagination links
            // Scroll to top of Resource list
            $('html, body').animate({
                scrollTop: $('#bulletinsList').offset().top - 200
            }, 200);
            filterBulletins();
        });

        // Scrollspy classes
        $('.slide-in-bottom-md').attr('uk-scrollspy', 'cls: uk-animation-slide-bottom-medium; delay: 350');
        $('.slide-in-left-md').attr('uk-scrollspy', 'cls: uk-animation-slide-left-medium; delay: 350');
        $('.slide-in-right-md').attr('uk-scrollspy', 'cls: uk-animation-slide-right-medium; delay: 350');
        $('.slide-in-bottom-sm').attr('uk-scrollspy', 'cls: uk-animation-slide-bottom-small; delay: 350');
        $('.slide-in-left-sm').attr('uk-scrollspy', 'cls: uk-animation-slide-left-small; delay: 350');
        $('.slide-in-right-sm').attr('uk-scrollspy', 'cls: uk-animation-slide-right-small; delay: 350');
        $('.fade-in').attr('uk-scrollspy', 'cls: uk-animation-fade; delay: 350');
        $('.slide-in-bottom-sm-children').attr('uk-scrollspy', 'target: > *; cls: uk-animation-slide-bottom-small; delay: 350');
        $('.slide-in-bottom-md-children').attr('uk-scrollspy', 'target: > *; cls: uk-animation-slide-bottom-medium; delay: 350');
        $('.slide-in-left-sm-children').attr('uk-scrollspy', 'target: > *; cls: uk-animation-slide-left-small; delay: 350');
    });
});